import { pushToDataLayer } from "../pushToDatalayer";

/**
 * Track events for the search bar and search results.
 *
 * @returns {void}
 */
function initSearchTracking() {
  trackSearchbarEvents();
  trackSearchResultsEvents();
}

/**
 * Track search bar events. These include:
 * - Focus on search bar
 * - Click on autosuggest
 * - Click on quick search item
 * - Submit search
 *
 * @returns {void}
 */
function trackSearchbarEvents() {
  // Get the header search element
  const searchElement = document.querySelector(".header-vts__search");
  if (!searchElement) return;

  // Track focus on search bar
  const searchInput = searchElement.querySelector(".header-vts__search-input");
  searchInput.addEventListener("focus", () => {
    pushToDataLayer("search", {
      eventCategory: "search",
      eventAction: "focus",
      eventLabel: "search focus",
    });
  });

  /**
   * Track clicks on autosuggest items.
   *
   * @param {HTMLElement} searchElement The search element
   * @returns {void}
   */
  function trackAutoSuggestClicks(searchElement) {
    // TODO - Fix
    const suggestions = searchElement.querySelector(".autocomplete-suggestions");
    if (!suggestions) return;
    suggestions.addEventListener("click", (e) => {
      const target = e.target.closest(".autocomplete-suggestion");
      if (!target) return;

      pushToDataLayer("search", {
        eventCategory: "search",
        eventAction: "click",
        eventLabel: "autosuggest",
        eventValue: target.textContent,
      });
    });
  }

  /**
   * Track clicks on quick search items.
   *
   * @param {HTMLElement} searchElement The search element
   * @returns {void}
   */
  function trackQuickSearchClicks(searchElement) {
    const quickSearch = searchElement.querySelector(".header-vts__groups");
    if (!quickSearch) return;
    quickSearch.addEventListener("click", (e) => {
      const target = e.target.closest(".header-vts__groups li");
      if (!target) return;

      pushToDataLayer("search", {
        eventCategory: "search",
        eventAction: "click",
        eventLabel: "quick search",
        eventValue: target.textContent,
      });
    });
  }

  trackAutoSuggestClicks(searchElement);
  trackQuickSearchClicks(searchElement);
}

/**
 * Track search results events. These include:
 * - Click on search result
 *   - Title of the search result
 *   - Type of the search result (document, part, product, video, etc.)
 * - Click on filter
 *   - Filter name
 *
 * @returns {void}
 */
function trackSearchResultsEvents() {
  // TODO - Implement tracking for search results
}

export default initSearchTracking;
